//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_CONTACTOS_EMPRESA = "obtenerContactosEmpresa";
export const OBTENER_CONTACTOS_SOCIO_EXTRANJERO = "obtenerContactosSocioExtranjero";
export const OBTENER_CONTACTOS_INSTITUCION = "obtenerContactosInstitucion";
export const OBTENER_CONTACTO= "obtenerContacto";
export const REGISTRAR_CONTACTO_EMPRESA_INSTITUCION = "registrarContacto";
export const ACTUALIZAR_CONTACTO = "actualizarContacto";
// mutation types
export const SET_CONTACTOS = "setTipoDocumentos";
export const SET_CONTACTO = "setTipoDocumento";

const state = {
    contactos: [],
    contacto:[],
}

const getters = {
    obtenerContactos(state) {
      return state.contactos;
    },
}

const actions = {
    //Obtener los contactos por empresa a traves de su id
    async [OBTENER_CONTACTOS_EMPRESA](context, params) {

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=api/Contactos/GetContactosByEmpresa/${params.estadoId}/${params.empresaId}`, '')
                .then(({ data }) => {
                    context.commit(SET_CONTACTO, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    //Obtener los contactos por empresa/socio extranjero a traves de su id
    async [OBTENER_CONTACTOS_SOCIO_EXTRANJERO](context, params) {

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=api/Contactos/GetContactosBySocioExtrangero/${params.estadoId}/${params.empresaId}`, '')
                .then(({ data }) => {
                    context.commit(SET_CONTACTO, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },


    //Obtener los contactos para instituciones a traves de su id
    async [OBTENER_CONTACTOS_INSTITUCION](context, params) {

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=api/Contactos/GetContactosByInstitucion/${params.estadoId}/${params.empresaId}`, '')
                .then(({ data }) => {
                    context.commit(SET_CONTACTO, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },


    async [REGISTRAR_CONTACTO_EMPRESA_INSTITUCION](context, data){
        console.log(data)
        //console.log(datosEmpresa)
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Contactos`, data)
                .then(({ data }) => {
                    context.commit(SET_CONTACTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    //Obtener tipos de documento por estado, por tipo socio y por sub tipo socio
   /* async [OBTENER_CONTACTOS_POR_SOCIO](context, params) {

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=api/Tipo_Documentos/GetTipoDocumentoActivos/${params.estadoId}/${params.tipoSocioId}/${params.subTipoSocioId}`, '')
                .then(({ data }) => {
                    context.commit(SET_CONTACTOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },


    

    async [OBTENER_CONTACTO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Empresas/`)
                .then(({ data }) => {
                    context.commit(SET_CONTACTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },

   
    
    async [ACTUALIZAR_CONTACTO](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Empresas/UpdateEmpresas/`, datos.datosEmpresa)
                .then(({ data }) => {
                    context.commit(SET_CONTACTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }*/

  }

const mutations = {
    [SET_CONTACTOS](state, data) {
        state.tipoDocumentos = data;
    },

    [SET_CONTACTO](state, data) {
        state.archivo = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}